import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

export interface TwoFactorAuthSettingsDTO {
  email: string | null;
  mobilePhoneNumber: string | null;
  is2FAEnabled: boolean;
  is2FARequired: boolean;
}

interface FetcherParams {
  clientId: string;
}

const fetchTwoFactorAuthSettings = async ({
  clientId,
}: FetcherParams): Promise<TwoFactorAuthSettingsDTO> =>
  authFetch(urlWithParams('/Consumer/Orion2FASettings', { clientId }));

interface Params {
  clientId: string;
}

export const useTwoFactorAuthSettings = ({ clientId }: Params) => {
  return useQuery(queryKeys.TwoFactorAuthSettings(clientId), () =>
    fetchTwoFactorAuthSettings({ clientId }),
  );
};
